import React, { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import styles from "./Sidebar.module.css";
import logo from "../../../assets/logo.svg";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const userRole = localStorage.getItem("adminRole");

  const filteredSidebarData = SidebarData.filter((item) =>
    item.roles.includes(userRole)
  );

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (path, roles) => {
    if (roles.includes(userRole)) {
      navigate(path);
    } else {
      alert("You are not eligible to access it");
    }
  };

  return (
    <>
      <div
        className={`${styles.overlay} ${isOpen ? styles.active : ""}`}
        onClick={toggleSidebar}
      ></div>
      <div className={styles.burgerIcon} onClick={toggleSidebar}>
        {isOpen ? "✖" : "☰"}
      </div>
      <div className={`${styles.sidebar} ${isOpen ? styles.open : ""}`}>
        <img
          onClick={() => navigate("/dashboard")}
          src={logo}
          alt="Logo"
          className={styles.logo}
        />
        <ul>
          {filteredSidebarData.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  isActive ? styles.activeLink : styles.sidebarLink
                }
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation(item.path, item.roles);
                }}
              >
                {item.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
